import { TV_PLAN_STATUS } from 'app-constants'

export const TV_PLAN_STATUS_CLASSNAME = {
  [TV_PLAN_STATUS.ACTIVE]: '-active',
  [TV_PLAN_STATUS.INACTIVE]: '-inactive',
}
